
    var riot = require('riot')
    import modalMixin from 'static/script/app/ui/mixin/modal-mixin';
riot.tag2('contact-modal-success', '<div name="modalBackground" class="modal-background-without-transition modal-default" data-modal-background data-modal-close-trigger riot-style="z-index: 10000; height: {modalHeight}px" data-clickable-list-ignore-click onclick="{onClose}" if="{showModal}"> <div name="modal" class="modal" data-modal> <button class="modal-close" onclick="{onClose}"></button> <div class="messaging-modal-body"> <div class="messaging-modal-body-icon"> <span class="check--before"></span> </div> <h2 class="messaging-modal-title text-center">Ditt meddelande är skickat</h2> <p class="messaging-modal-text text-center">Mottagaren kan nu svara till din e-postadress.</p> <button class="secondary-action" onclick="{this.onOk}">Stäng</button> </div> </div> </div>', '', '', function(opts) {

        this.mixin(modalMixin);

        this.onOk = function(evt) {
            this.bus.trigger('ui:contact-modal:message-sent-confirmed', evt);
        }.bind(this);

        this.on('mount', function () {
            this.bus.on('data:contact-service:message-sent', function (payload) {
                this.sending = false;
                this.update();
            });

            this.bus.on('data:contact-service:message-sent-success', this.show)
            this.bus.on('ui:contact-modal:on-close', this.close);
        });
});

    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/contact/contact-modal-success.riot.html